"use client";

import { useDrawer } from "@/hooks";

type DrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  position?: "left" | "right";
  width?: string;
  maxWidth?: string;
  titleId?: string;
  overlayContent?: React.ReactNode;
};

export function Drawer({
  isOpen,
  onClose,
  children,
  position = "left",
  width = "86vw",
  maxWidth = "340px",
  titleId,
  overlayContent,
}: DrawerProps) {
  const panelRef = useDrawer(isOpen, onClose);

  const isLeft = position === "left";

  return (
    <>
      <div
        className={[
          "fixed left-0 right-0 bottom-0 top-[var(--header-height)] z-40 bg-black/55 backdrop-blur-[2px] transition-opacity duration-200",
          "m-0 p-0",
          isOpen ? "opacity-100" : "opacity-0 pointer-events-none",
        ].join(" ")}
        onClick={onClose}
        style={{ margin: 0, padding: 0 }}
      >
        {overlayContent}
      </div>

      {/* `<div>` not `<aside>` so role="dialog" is allowed (ARIA does not
          permit role=dialog on <aside>; lighthouse a11y flags this). */}
      <div
        ref={panelRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
        style={{
          width: width,
          maxWidth: maxWidth,
          margin: 0,
          padding: 0,
        }}
        className={[
          "fixed bottom-0 top-[var(--header-height)] z-[60] flex flex-col overflow-hidden",
          "m-0 p-0",
          isLeft ? "left-0" : "right-0",
          isLeft ? "border-r" : "border-l",
          "border-[#2a475e]/70",
          isLeft
            ? "bg-gradient-to-r from-[#16202d]/80 via-[#1a2838]/80 to-[#16202d]/80"
            : "bg-gradient-to-l from-[#16202d]/80 via-[#1a2838]/80 to-[#16202d]/80",
          "backdrop-blur-md",
          "shadow-2xl",
          "transform transition-transform duration-300 ease-out",
          isOpen
            ? "translate-x-0"
            : isLeft
            ? "-translate-x-full"
            : "translate-x-full",
          "focus:outline-none",
        ].join(" ")}
      >
        <div className="flex-1 min-h-0 overflow-y-auto overscroll-contain win-scrollbar">
          {children}
        </div>

        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-12 bg-gradient-to-t from-[#0f1922]/90 to-transparent" style={{ zIndex: 0 }} />
      </div>
    </>
  );
}
